import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { Sheet, SheetContent, SheetTrigger } from './ui/Sheet';
import { useBooking } from './BookingContext';
export function Navigation() {
  const {
    openBooking
  } = useBooking();
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 72;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const navLinks = [{
    label: 'THE TREATMENT',
    id: 'treatment'
  }, {
    label: 'THE EVENING',
    id: 'evening'
  }, {
    label: 'DETAILS',
    id: 'details'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bc-ease ${isScrolled ? 'backdrop-blur-[20px] saturate-[140%]' : ''}`} style={{
    background: isScrolled ? 'rgba(7, 7, 12, 0.6)' : 'transparent',
    height: '72px'
  }} data-id="element-118">
      <div className="container mx-auto px-6 h-full flex items-center justify-between" data-id="element-119">
        <button onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} className="flex items-center" aria-label="Be CLINICAL — back to top" data-id="element-120">
          <img src="https://cdn.magicpatterns.com/uploads/pVcT9SJxmKezCoeaC5imfz/Be_Clinical_logo_white_hex.png" alt="Be CLINICAL" className="h-9 md:h-10 w-auto" data-id="element-121" />
        </button>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-122">
          {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className="text-bc-bone-3 hover:text-bc-bone font-sans text-xs tracking-label uppercase transition-colors bc-ease" data-id="element-123">
              {link.label}
            </button>)}
          <Button onClick={openBooking} className="rounded-full bg-transparent border border-bc-pink text-bc-bone text-xs tracking-label uppercase bc-glow-box-soft hover:bc-glow-box transition-all bc-ease px-6" data-id="element-124">
            RESERVE
          </Button>
        </div>

        {/* Mobile nav */}
        <Sheet data-id="element-125">
          <SheetTrigger asChild data-id="element-126">
            <button className="md:hidden text-bc-bone p-2" data-id="element-127">
              <Menu className="w-6 h-6" strokeWidth={1.5} data-id="element-128" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-bc-surface border-l border-hairline w-[280px]" data-id="element-129">
            <div className="flex flex-col gap-6 mt-8" data-id="element-130">
              {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className="text-bc-bone font-sans text-sm tracking-label uppercase text-left hover:text-bc-pink transition-colors bc-ease" data-id="element-131">
                  {link.label}
                </button>)}
              <Button onClick={openBooking} className="rounded-full bg-transparent border border-bc-pink text-bc-bone text-xs tracking-label uppercase bc-glow-box-soft hover:bc-glow-box transition-all bc-ease w-full mt-4" data-id="element-132">
                RESERVE
              </Button>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </nav>;
}